import { render, staticRenderFns } from "./MultiInputSumCpt.vue?vue&type=template&id=24deb450&scoped=true&"
import script from "./MultiInputSumCpt.vue?vue&type=script&lang=ts&"
export * from "./MultiInputSumCpt.vue?vue&type=script&lang=ts&"
import style0 from "./MultiInputSumCpt.vue?vue&type=style&index=0&id=24deb450&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24deb450",
  null
  
)

export default component.exports